import { UserProvider } from 'context';
import { Route, RouteProps, Redirect } from 'react-router';

interface IAllowRole extends RouteProps {
  allowRole: string;
}

export const ProtectedRoute = ({
  children,
  allowRole,
  ...props
}: IAllowRole) => {
  const isAuthenticated = localStorage.getItem('user');
  const role = localStorage.getItem('role');

  return (
    <Route
      {...props}
      render={({ location }) => {
        return isAuthenticated && role === allowRole ? (
          <UserProvider>{children}</UserProvider>
        ) : (
          <Redirect
            to={{
              pathname: `/${allowRole}`,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};
